// @ts-nocheck
import {
  buildNormalizedAliases,
  buildColumnMap,
  buildRecordFromColumnMap,
  cleanText,
  guessPharmaceuticalCompanyName,
  normalizeHeader,
  shouldSkipRecord,
} from './settlementTemplateHelpers.js';

const SAMSUNG_FIELD_ALIASES = {
  hospitalName: ['요양기관명'],
  drugCode: ['보험코드'],
  drugName: ['제품명'],
  feeRate: ['제약수수료율'],
  quantity: ['수량'],
  unitPrice: ['단가'],
  prescriptionAmount: ['처방금액'],
  settlementAmount: ['수수료합계'],
  note: ['비고'],
};

const REQUIRED_HEADERS = [
  '요양기관명',
  '보험코드',
  '제품명',
  '처방금액',
  '제약수수료율',
  '수수료합계',
];

function isSamsungProfile(profile) {
  const headerAreaTokens = profile.headerAreaRows.flatMap((row) => row.cells);

  return (
    REQUIRED_HEADERS.every((header) =>
      profile.headers.some(
        (candidate) => normalizeHeader(candidate) === normalizeHeader(header),
      ),
    ) &&
    headerAreaTokens.some((candidate) =>
      normalizeHeader(candidate).includes(normalizeHeader('삼성제약')),
    )
  );
}

const samsungPharmTemplate = {
  id: 'samsung-pharm',
  name: '삼성제약 템플릿',
  match(context) {
    return context.headerProfiles.some(isSamsungProfile);
  },
  extract(context) {
    const targetProfile = context.headerProfiles.find(isSamsungProfile);
    if (!targetProfile) {
      return {
        rows: [],
        pharmaceuticalCompanyName: guessPharmaceuticalCompanyName(
          context.file.name,
        ),
        templateName: this.name,
      };
    }

    const sheetName = targetProfile.sheetName;
    const rows = context.sheetRowsMap[sheetName] || [];
    const headerRow = rows[targetProfile.headerRowIndex] || [];
    const columnMap = buildColumnMap(
      headerRow,
      buildNormalizedAliases(SAMSUNG_FIELD_ALIASES),
    );
    const detectedPharmaceuticalCompany = '삼성제약';
    const extractedRows = [];

    rows.slice(targetProfile.headerRowIndex + 1).forEach((row, rowOffset) => {
      if (!Array.isArray(row) || row.every((cell) => cleanText(cell) === '')) {
        return;
      }

      const insuranceCode = cleanText(row[columnMap.drugCode]);
      if (!insuranceCode) {
        return;
      }

      const record = buildRecordFromColumnMap({
        row,
        columnMap,
        fileName: context.file.name,
        sheetName,
        rowIndex: targetProfile.headerRowIndex + rowOffset + 1,
        templateId: this.id,
        detectedPharmaceuticalCompany,
      });

      if (shouldSkipRecord(record, row)) {
        return;
      }

      extractedRows.push(record);
    });

    return {
      rows: extractedRows,
      pharmaceuticalCompanyName: detectedPharmaceuticalCompany,
      templateName: this.name,
    };
  },
};

export default samsungPharmTemplate;
